<template>
  <div
    class="q-pa-sm"
    style="background-color: #f0f2f5; border-bottom: 1px solid #e0e0e0;"
  >
    <div class="row items-start">
      <div
        class="col"
        style="min-width: 0;"
      >
        <BaseQuotedMessage
          :message="message"
          :contact-name="contactName"
        />
      </div>
      <div class="col-auto">
        <q-btn
          flat
          round
          dense
          icon="mdi-close"
          @click="$emit('cancel-reply')"
        >
          <q-tooltip>Cancelar Resposta</q-tooltip>
        </q-btn>
      </div>
    </div>
  </div>
</template>

<script>
import BaseQuotedMessage from './BaseQuotedMessage.vue'

export default {
  name: 'AttendanceChatInputReplyPreview',
  components: { BaseQuotedMessage },
  props: {
    message: {
      type: Object,
      required: true
    },
    contactName: {
      type: String,
      default: ''
    }
  }
}
</script>
